import PropTypes from "prop-types";
import { useState, useEffect, useMemo } from "react";
import { getEmpleados, getIncidentes, createIncidente, openIncidenteById, deleteNMIncidenteProductoById, getProductosbyIncidente, updateIncidenteById, deleteIncidenteById, getTipoIncidentes} from "../api";

const FilterTableIncidente = () => {
  const [sortField, setSortField] = useState("fecha_incidente"); // default: por fecha
  const [sortOrder, setSortOrder] = useState("desc");            // default: reciente → antigu
  const [Incidente, setIncidente] = useState([]);
  const [filteredIncidente, setFilteredIncidente] = useState([]);
  const [formData, setFormData] = useState({ id: 0, nota: "", id_tipo_incidente: "", id_empleado: "", usuario: "", fecha_incidente: "", estado: "" });
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState("");
  const [idSeleccionado, setIdSeleccionado] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [responsable, setResponsable] = useState("");
  const [empleados, setEmpleados] = useState([]);
  const [productos, setProductos] = useState([]);
  const [historia, setHistoria] = useState(false);
  const [tipoIncidentes, setTipoIncidentes] = useState([]);

  const getComparable = (item, field) => {
  switch (field) {
    case "nota":            return item.nota ?? "";
    case "tipo_incidente":  return item.tipo_incidente ?? "";
    case "usuario":         return item.usuario ?? item.empleado ?? "";
    case "estado":          return item.estado ?? "";
    case "fecha_incidente": return item.fecha_incidente ?? "";
    default:                return "";
  }
};

  const sortedIncidente = useMemo(() => {
    const arr = [...filteredIncidente];
    arr.sort((a, b) => {
      if (sortField === "fecha_incidente") {
        const da = new Date(getComparable(a, "fecha_incidente"));
        const db = new Date(getComparable(b, "fecha_incidente"));
        const diff = da - db; // positivo si a > b
        return sortOrder === "asc" ? diff : -diff;
      } else {
        const as = String(getComparable(a, sortField));
        const bs = String(getComparable(b, sortField));
        const cmp = as.localeCompare(bs, "es", { sensitivity: "base", numeric: true });
        return sortOrder === "asc" ? cmp : -cmp;
      }
    });
    return arr;
  }, [filteredIncidente, sortField, sortOrder]);

  const fetchDropdownData = async () => {
    try {
      const [empleadosResponse, tipoIncidentesResponse] = await Promise.all([
        getEmpleados(),
        getTipoIncidentes()
      ]);
      setEmpleados(empleadosResponse.data);
      setTipoIncidentes(tipoIncidentesResponse.data);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };

  const fetchIncidente = async () => {
    try {
      const response = await getIncidentes();
      setIncidente(response.data);
      setFilteredIncidente(response.data); // Initially show all items
    } catch (error) {
      console.error("Error fetching incidente:", error);
      setError("Error loading data");
    }
  };

  useEffect(() => {
    fetchIncidente();
    fetchDropdownData();
  }, []);

  useEffect(() => {
    const t = filterText.toLowerCase();
    if (t) {
      const filtered = Incidente.filter((i) => {
        const idMatch       = String(i.id ?? "").includes(t);
        const notaMatch     = String(i.nota ?? "").toLowerCase().includes(t);
        const usuarioMatch  = String(i.usuario ?? i.empleado ?? "").toLowerCase().includes(t);
        const tipoMatch     = String(i.tipo_incidente ?? "").toLowerCase().includes(t);
        return idMatch || notaMatch || usuarioMatch || tipoMatch;
      });
      setFilteredIncidente(filtered);
    } else {
      setFilteredIncidente(Incidente);
    }
  }, [filterText, Incidente]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (isEditing) {
        await updateIncidenteById(formData.id, { nota: formData.nota, id_tipo_incidente: formData.id_tipo_incidente, id_empleado: formData.id_empleado, usuario: formData.usuario,fecha_incidente: formData.fecha_incidente, estado: formData.estado });
        alert("Incidente actualizado con éxito.");
      } else {
        await createIncidente(formData);
        alert("Incidente registrado con éxito.");
      }
      setFormData({ id: 0, nota: "", id_tipo_incidente: "", id_empleado: "", usuario: "", fecha_incidente: "", estado: "" });
      setIsEditing(false);
      fetchIncidente();
    } catch (error) {
      console.error("Error procesando la incidente:", error);
    }
  };

  const handleEdit = (Incidente) => {
    setFormData(Incidente);
    setIsEditing(true);
  };

  const handleDetalles = async (Incidente) => {
    try {
      setResponsable(Incidente.empleado);
      const response = await getProductosbyIncidente(Incidente.id);
      setIdSeleccionado(Incidente.id)

      setProductos(response.data);
    } catch (error) {
      console.error("Error fetching producto:", error);
      setError("Error loading data");
    }
    setHistoria(true);
  };

  const handleCloseHistoriaModal = () => {
    setHistoria(false);
  };

  const handleClearFilters = () => {
    setIsEditing(false);
    setFormData({ id: 0, nota: "", id_tipo_incidente: "", id_empleado: "", usuario: "", fecha_incidente: "", estado: "" });
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de cerrar esta incidente?")) {
      try {
        await deleteIncidenteById(id);
        alert("Incidente cerrado con éxito.");
        fetchIncidente();
      } catch (error) {
        console.error("Error eliminando la incidente:", error);
      }
    }
  };

    const handleOpen = async (id) => {
    if (window.confirm("¿Estás seguro de reabrir este incidente?")) {
      try {
        await openIncidenteById(id);
        alert("Incidente abierto con éxito.");
        await fetchIncidente();
      } catch (error) {
        console.error("Error abriendo la incidente:", error);
      }
    }
  };
  
  const handleClose = async (idNmIncidenteProducto) => {
    if (window.confirm("¿Estás seguro de cerrar este registro?")) {
      try {
        await deleteNMIncidenteProductoById(idNmIncidenteProducto);
        alert("Registro cerrado con éxito.");

        // recarga tabla principal
        await fetchIncidente();

        // recarga productos del incidente actualmente seleccionado (modal)
        if (idSeleccionado) {
          try {
            const response = await getProductosbyIncidente(idSeleccionado);
            setProductos(response.data);
          } catch (error) {
            console.error("Error recargando productos:", error);
          }
        }
      } catch (error) {
        console.error("Error eliminando el registro:", error);
      }
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <center><h2>{isEditing ? "Editar Incidente" : "Agregar Incidente"}</h2></center>
        <div className="input-group">
          <input
            type="text"
            name="id"
            value={formData.id}
            onChange={handleChange}
            className="input"
            disabled={isEditing}
            hidden
          />
        </div>
        <div className="input-group">
          <label className="label3">Descripción</label>
          <input
            type="text"
            name="nota"
            value={formData.nota}
            onChange={handleChange}
            className="input-form-2"
          />
        </div>

        <div className="input-group">
        <label className="label2">Personal</label>
          <select
            name="id_empleado"
            value={formData.id_empleado}
            onChange={handleChange}
            className="input-form-1"
          >
            {empleados.map((empleado) => (
              <option key={empleado.id} value={empleado.id}>
                {empleado.nombres} {empleado.apellido_paterno}
              </option>
            ))}
          </select>

          <label className="label2">Tipo Incidente</label>
          <select
            name="id_tipo_incidente"
            value={formData.id_tipo_incidente}
            onChange={handleChange}
            className="input-form-1"
          >
            {tipoIncidentes.map((tipoIncidentes) => (
              <option key={tipoIncidentes.id} value={tipoIncidentes.id}>
                {tipoIncidentes.descripcion}
              </option>
            ))}
          </select>
          <label className="label2">Estado</label>
          <select
            name="estado"
            value={formData.estado}
            onChange={handleChange}
            className="input-form-1"
          >

            <option key="abierto" value="abierto">Abierto</option>
            <option key="cerrado" value="cerrado">Cerrado</option>

          </select>
          <label className="label2">Fecha</label>
          <input
            type="date"
            name="fecha_incidente"
            value={formData.fecha_incidente}
            onChange={handleChange}
            className="input-form-1"
          />
        </div>
        <center>
          <button type="submit" className="button-form-blue">
          {isEditing ? "Actualizar" : "Registrar"}
          </button>
          <button  type="reset" className="button-form-gray" onClick={handleClearFilters}>
              Cancelar
          </button>
        </center>
      </form>
      <hr />
      <div className="input-group">
        <input
          type="text"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Buscar por id, descripción, tipo_incidente o usuario..."
          className="input3"
        />
      </div>
        <div className="input-group">
          <label className="label2">Ordenar por</label>
          <select
            className="input-form-1"
            value={sortField}
            onChange={(e) => setSortField(e.target.value)}
          >
            <option value="nota">Descripción</option>
            <option value="tipo_incidente">Tipo Incidente</option>
            <option value="usuario">Usuario</option>
            <option value="estado">Estado</option>
            <option value="fecha_incidente">Fecha</option>
          </select>

          <label className="label2">Dirección</label>
          <select
            className="input-form-1"
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
          >
            {sortField === "fecha_incidente" ? (
              <>
                <option value="desc">Más reciente → antiguo</option>
                <option value="asc">Más antiguo → reciente</option>
              </>
            ) : (
              <>
                <option value="asc">A → Z</option>
                <option value="desc">Z → A</option>
              </>
            )}
          </select>
        </div>
      {sortedIncidente.length === 0 ? (
        <p>{error || "Cargando datos..."}</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
            <th colSpan="2">Acciones</th>
              <th>ID</th>
              <th>Descripción</th>
              <th>tipo_incidente</th>
              <th>usuario</th>
              <th>Fecha</th>
              <th>Estado</th>
              <th colSpan="2"></th>
            </tr>
          </thead>
          <tbody>
            {sortedIncidente.map((Incidente) => (
              <tr key={Incidente.id}>
                <td>
                {["Prestamo Material", "Dañado", "Reparacion", "Destruccion", "Extraviado"].includes(Incidente.tipo_incidente) && (
                  <button
                    onClick={() => handleDetalles(Incidente)}
                    className="button-gray"
                  >
                    Detalles
                  </button>
                )}
                </td><td>
                  <button onClick={() => handleEdit(Incidente)} className="button-table-blue">
                    Editar
                  </button>
                </td>
                <td>{Incidente.id}</td>
                <td>{Incidente.nota}</td>
                <td>{Incidente.tipo_incidente}</td>
                <td>{Incidente.empleado}({Incidente.id_empleado})</td>
                <td>{Incidente.fecha_incidente}</td>
                <td>{Incidente.estado}</td>
                <td>
                  <button onClick={() => handleOpen(Incidente.id)} className="button-table-blue">
                    Reabrir
                  </button>
                </td>
                <td>
                  <button onClick={() => handleDelete(Incidente.id)} className="button-table-red">
                    Cerrar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {historia && (
        <div className="modal-overlay" onClick={handleCloseHistoriaModal}>
          <div className="modal-historia-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={handleCloseHistoriaModal}>
              ✖
            </button>
            <div><h2>Detalles de incidente {idSeleccionado}:</h2>
            <h3>Responsable {responsable}:</h3></div>
            <div>
            <table className="table-de-modal">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Codigo</th>
                  <th>Descripción</th>
                  <th>Cantidad</th>
                  <th>Estado</th>
                  <th>Nota</th>
                  <th>Tipo</th>
                  <th>Fecha Creación</th>
                  <th>Fecha Cierre</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {productos.map((producto, index) => (
                  <tr key={index}>
                    <td>{producto.id_producto}</td>
                    <td>{producto.codigo}</td>
                    <td>{producto.descripcion}</td>
                    <td>{producto.cantidad}</td>
                    <td>{producto.estado}</td>
                    <td>{producto.nota}</td>
                    <td>{producto.tipo}</td>
                    <td>{producto.fecha_creacion}</td>
                    <td>
                      {producto.fecha_cierre === "1990-01-01 00:00:00" ? "" : producto.fecha_cierre}
                    </td>
                    <td>
                      <button onClick={() => handleClose(producto.id_nm_incidente_producto)} className="button-table-blue">
                      Cerrar
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table></div>
            
          </div>
        </div>
      )}

    </div>
  );
};

FilterTableIncidente.propTypes = {
  incidente: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      nota: PropTypes.string,
    })
  ),
};

export default FilterTableIncidente;